import React, { useEffect } from 'react';
import './salary.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import SalaryHeader from "../../components/PagesHeaders/SalaryHeader/SalaryHeader";
import { getSalariesDataSagaAction } from "../../redux/sagaActions";
import { setSalariesDataAction } from "../../redux/rootReducer";
import Checkbox from "../../components/Checkbox/Checkbox";
import Tippy from '@tippyjs/react';

const Salary = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const salaries_data = useSelector(state => state.salaries_data);
    const subscription_types = useSelector(state => state.subscription_types);

    useEffect(() => {
        if (!currentEstablishment) return;
        // Получение данных
        dispatch(getSalariesDataSagaAction());
    }, []);
    return (
        <>
            <Header component={ <SalaryHeader/> } />
            <div className="page">
                <div className="salary">
                    <div className="table__header">
                        <div className="table__caption">Расчёт зарплат</div>
                    </div>
                    <div className="salary__options">
                        <div className="salary__option">
                            <div className="salary__option-caption input__caption">Стоимость занятия</div>
                            <input type="text" className="salary__option-input input"
                                value={ salaries_data.coach_workout_cost }
                                onInput={ event => dispatch(setSalariesDataAction({
                                    ...salaries_data,
                                    coach_workout_cost: event.target.value
                                })) }
                            />
                        </div>

                        <div className="salary__option">
                            <div className="salary__option-caption input__caption">Надбавка за клиента</div>
                            <input type="text" className="salary__option-input input"
                                   value={ salaries_data.coach_client_cost }
                                   onInput={ event => dispatch(setSalariesDataAction({
                                       ...salaries_data,
                                       coach_client_cost: event.target.value
                                   })) }
                            />
                        </div>
                    </div>

                    <div className="salary__options">
                        <Tippy content={ `Стоимость тренировки будет рассчитана по формуле:\n стоимость абонемента / количество тренировок` }>
                            <div className="salary__option" style={{ marginTop: '15px', width: 'initial' }}>
                                <Checkbox
                                    active={ salaries_data.consider_subscription_cost === '1' }
                                    caption={ 'Учитывать стоимость абонемента' }
                                    handler={ () => {
                                        dispatch(setSalariesDataAction({
                                            ...salaries_data,
                                            consider_subscription_cost: salaries_data.consider_subscription_cost === '1' ? '0' : '1'
                                        }));
                                    } }
                                />
                            </div>
                        </Tippy>
                        {
                            salaries_data.consider_subscription_cost === '1' &&
                            <div className="salary__option">
                                <div className="salary__option-caption input__caption">% от стоимости абонемента</div>
                                <input type="text" className="salary__option-input input"
                                       value={ salaries_data.consider_subscription_percent }
                                       onInput={ event => dispatch(setSalariesDataAction({
                                           ...salaries_data,
                                           consider_subscription_percent: event.target.value
                                       })) }
                                />
                            </div>
                        }

                        <div className="salary__option">
                            <div className="salary__option-caption input__caption">Процент от разового занятия</div>
                            <input type="text" className="salary__option-input input"
                                   value={ salaries_data.one_time_percent }
                                   onInput={ event => dispatch(setSalariesDataAction({
                                       ...salaries_data,
                                       one_time_percent: event.target.value
                                   })) }
                            />
                        </div>
                    </div>

                    <div className="salary__options salary__options--column">
                        <div className="salary__caption">Укажите стоимость занятий здесь, если она различается</div>
                        { subscription_types.map(elem => {
                            return (
                                <div className="salary__option" key={ elem.id }>
                                    <div className="salary__option-caption input__caption">{ elem.name }</div>
                                    <input type="text" className="salary__option-input input"
                                        value={ salaries_data?.workouts_types_cost?.[elem.id] || '' }
                                        onInput={ event => dispatch(setSalariesDataAction({
                                            ...salaries_data,
                                            workouts_types_cost: { ...salaries_data.workouts_types_cost, [elem.id]: event.target.value }
                                        })) }
                                    />
                                </div>
                            );
                        }) }
                    </div>

                    <div className="salary__employees">
                        <div className="table__row table__row--header table__row--salary">
                            <div className="table__cell">Тренер</div>
                            <div className="table__cell">Занятия</div>
                            <div className="table__cell">Кол-во посетителей</div>
                            <div className="table__cell">Сумма</div>
                        </div>
                        {
                            salaries_data.employees.map(elem => {
                                return (
                                    <div className="table__row table__row--salary" key={ elem.id }>
                                        <div className="table__cell">{ elem.name }</div>
                                        <div className="table__cell">{ elem.group }</div>
                                        <div className="table__cell">{ elem.workouts }</div>
                                        <div className="table__cell">{ elem.sum }</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Salary;